<div>
    <h2>{{'mantenimientoMunicipios.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.pais' | translate}} *</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.provincia' | translate}}</label>
                <app-filterable-list [itemsList]="provincias" [selectedItem]="filtersForm.get('provincia')"
                    [disabled]="disabledProvincias" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.municipio' | translate}}</label>
                <app-filterable-list [itemsList]="municipiosFiltro" [selectedItem]="filtersForm.get('municipio')"
                    [disabled]="disabledMunicipios" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
                    (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
                    (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="radio-group move-left">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
            </div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="id sortable" (click)="toOrderBy('x=> x.id', 1)">
                          {{'mantenimientoMunicipios.table.id' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.id')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.Pais.DesPaisDefecto', 2)">
                          {{'global.pais' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.Pais.DesPaisDefecto')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.Provincia.Des', 3)">
                          {{'global.provincia' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.Provincia.Des')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.des', 4)">
                          {{'global.municipio' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.des')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.codigoPostal', 5)">
                          {{'mantenimientoMunicipios.table.codigoPostal' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.codigoPostal')"></i></div>
                        </th>
                        <th class="date-long sortable" (click)="toOrderBy('x=> x.fechaIns', 6)">
                          {{'global.fecha.insercionShort' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.fechaIns')"></i></div>
                        </th>
                        <th class="date-long sortable" (click)="toOrderBy('x=> x.fechaUpd', 7)">
                          {{'global.fecha.actualizacionShort' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.fechaUpd')"></i></div>
                        </th>
                        <th class="action"><i class="fas fa-plus" (click)="create()" title="{{'mantenimientoMunicipios.tituloNew' | translate}}"></i></th>
                    </tr>
                </thead>
                <tbody *ngFor="let municipio of municipios; trackBy: trackByMunicipioId">
                    <tr>
                        <td class="id">{{municipio.id}}</td>
                        <td class="string">{{municipio.desPaisTraduccion}}</td>
                        <td class="string">{{municipio.desProvincia}}</td>
                        <td class="string">{{municipio.des}}</td>
                        <td class="string">{{municipio.codigoPostal}}</td>
                        <td class="date-long">{{municipio.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="date-long">{{municipio.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="actions">
                            <i class="fas fa-pencil-alt" (click)="update(municipio)" title="{{'titles.editar' | translate}}"></i>
                            <i class="far fa-trash-alt" (click)="askDelete(municipio)" title="{{'titles.eliminar' | translate}}"></i>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!municipios || (municipios && municipios.length < 1)">
                    <tr>
                        <td colspan="12">
                            {{ 'global.noContent' | translate }}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="municipios && municipios.length > 0" [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
        (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
    </app-paginator>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event;showWarning=$event;">
    </app-toast>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
        </header>
        <content>
            <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{ 'global.cancelar' | translate }}</button>
            <button (click)="delete()">{{ 'global.confirmar' | translate }}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{toEditId ? ('mantenimientoMunicipios.tituloEdit' | translate) : ('mantenimientoMunicipios.tituloNew' |
                translate)}}</h4>
        </header>
        <app-mps-new-edit [municipioId]="toEditId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
        </app-mps-new-edit>
    </div>
</div>
